import * as dateUtil from '../lib/dateUtil'

export default {
  data () {
    return {
      apiUrl: '/base-api-url/',
      url: '/base-url/',
      loading: true
    }
  },
  methods: {
    clearFilters () {
      this.filters = {...this.defaultFilters}
    },
    priceFormatter (row, column) {
      return this.common.formatPrice(row[column.property], true)
    },
    percentFormatter (row, column) {
      if (row[column.property]) {
        return row[column.property] + '%'
      }
      return ''
    },
    dateFormatter (row, column) {
      const date = new Date(row[column.property])
      return dateUtil.format(date, 'DD.MM.YYYY')
    },
    booleanFormatter (row, column) {
      return row[column.property] ? '✓' : ''
    }
  },
  created () {
    this.defaultFilters = {...this.$data.filters}
  },
  watch: {
    $route () {
      // console.info(this.$options.name, this.$route.path, this.url)
      if (this.$route.path === this.url) {
        this.$refs.datatable.loadData()
        // console.log('^^^^^^^^^^^^^^^^^^^^^^^ ')
      }
    }
  }
}
